import { useQuery } from 'react-query';
import { placeholdersQuery } from './usePlaceholders.query';
import { Placeholders } from '../../../types/models/placeholders/placeholders.types';

export const PLACEHOLDERS_QUERY_KEY = 'PLACEHOLDERS';

export const usePlaceholders = (names: string[]) => {
  return useQuery<Placeholders[], Error>(
    [PLACEHOLDERS_QUERY_KEY, names],
    () => placeholdersQuery(names),
    {
      cacheTime: 0,
      retry: true,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
    }
  );
};
